export default __webpack_public_path__ + "static/media/Ashwin Girish.0407bd12.jpg";